module.exports = __webpack_public_path__ + "img/hp-case-crystal.77c99cba.png";